import React from 'react'
import { Modal, SuspenseBoundary } from 'elements'
import ResolutionModal from './ResolutionModal'

export default function ResolutionModalContainer({
  modal,
  resolutionId,
  reportId,
  platformCompanyId,
  anomalyView,
}) {
  return (
    <Modal modal={modal}>
      <SuspenseBoundary>
        <ResolutionModal
          modal={modal}
          resolutionId={resolutionId}
          reportId={reportId}
          platformCompanyId={platformCompanyId}
          anomalyView={anomalyView}
        />
      </SuspenseBoundary>
    </Modal>
  )
}
